import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchVenueReservationSettingHistories } from '@/lib/venue/reservationSettingApi'

export function venueReservationSettingHistoriesQueryKey(venueId: string) {
  return ['venue', venueId, 'reservation-setting-histories'] as const
}

/**
 * 변경 이력(#758, 백엔드 #757 §3) — 커서 페이지네이션. 서버가 이미 인코딩된 `nextCursor` 를 주므로
 * `useCampaigns` 와 같은 방식으로 `getNextPageParam` 을 직접 선언한다.
 */
export function useVenueReservationSettingHistories(venueId: string) {
  return useInfiniteQuery({
    queryKey: venueReservationSettingHistoriesQueryKey(venueId),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchVenueReservationSettingHistories(venueId, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
